module.exports = __webpack_public_path__ + "media/theme/icon__status--unfulfilled-7447e496.svg";